export const faqJsonData = [
  {
    index: 1,
    ques: 'Why are all the LEDs blinking red continuously along with a constant beeping sound ?',
    ans: 'This indicates a critical alert in the lock. All LEDs blink red when there is a tamper alert.',
    category: 'general',
    keyword: ['LED', 'blinking', 'red', 'beeping', 'alert']
  },
  {
    index: 2,
    ques: 'Why am I unable to remove the lock cable from the lock?',
    ans: 'Ensure that the lock is not in a locked state, and retry unlock.',
    category: 'unlocking',
    keyword: ['lock', 'unlock', 'cable', 'remove', 'wire', 'locked']
  },
  {
    index: 3,
    ques: 'Why are no LEDs blinking on the display?',
    ans: 'The lock may be in power save mode or have a low battery. Create motion or charge the lock and check the LED display again.',
    category: 'general',
    keyword: ['LED', 'blinking', 'no LED', 'blank display']
  },
  {
    index: 4,
    ques: 'Why is only the last LED blinking red occasionally?',
    ans: 'This indicates a low battery. Charge the lock to resolve the issue',
    category: 'general',
    keyword: ['lock', 'CHG LED', 'chg']
  },
  {
    index: 5,
    ques: 'How can I ensure that the lock is in a GPS-reachable area and receiving a GPS signal?',
    ans: 'Place the lock in an open area without obstructions like walls or roofs that may block the GPS signal. Also check for the first LED (GPS LED) to blink green, this indicates that the lock is receiving a GPS signal.',
    category: 'general',
    keyword: ['general', 'GPS', 'gps', 'location']
  },
  {
    index: 6,
    ques: 'Why does the blue LED blink while unlocking the device?',
    ans: 'The blue LED indicates that the lock is processing an unlock command and attempting to communicate with the dashboard.Try to unlock the device again.',
    category: 'unlocking',
    keyword: ['unlock', 'blue led', 'led', 'blue', 'cable not coming out']
  },
  {
    index: 7,
    ques: 'Why does the lock heat up during charging?',
    ans: 'Slight heating is normal during charging. If the lock becomes excessively hot, disconnect it immediately.',
    category: 'general',
    keyword: ['lock', 'heating', 'heatup', 'charging']
  },
  {
    index: 8,
    ques: 'How can I reboot the lock from the dashboard?',
    ans: 'Go to the "Devices" section, select the lock, and choose the "Reboot" option from the device settings.',
    category: 'general',
    keyword: ['reboot', 'dashboard', 'web', 'settings']
  },
  {
    index: 9,
    ques: 'How can I lock the device if the cable cannot be inserted into the lock slots?',
    ans: 'Ensure the cable and slots are free from debris or damage. If the issue persists, reset the lock and try again.',
    category: 'unlocking',
    keyword: ['lock', 'unlock', 'cable', 'remove', 'wire', 'locked']
  },
  {
    index: 10,
    ques: 'Why does the lock occasionally produce extra beeping noises?',
    ans: 'Extra beeping can indicate a system alert, such as low battery, poor GPS signal, or unauthorized access attempts.',
    category: 'general',
    keyword: ['beeping', 'noise', 'alert', 'low battery']
  },
  {
    index: 11,
    ques: 'How do I set up my GPS smart lock for the first time?',
    ans: 'Follow these steps:\na. Unbox the Lock.\nb. Insert the Cable.\nc. Activate the device from the dashboard.\nd. Charge the lock.',
    category: 'general',
    keyword: ['smartlock', 'setup', 'steps to setup', 'first time']
  },
  {
    index: 12,
    ques: 'What happens if the GPS smart lock battery dies?',
    ans: 'The lock remains in its last state (locked or unlocked). You will need to charge it to regain functionality.',
    category: 'general',
    keyword: ['battery dead', 'low battery', 'charging', 'dead']
  },
  {
    index: 13,
    ques: 'What should I do if the GPS location is inaccurate?',
    ans: 'Ensure the lock is in an open area. If the issue persists, restart the device and wait for 5 minutes.',
    category: 'general',
    keyword: ['wrong location', 'GPS', 'inaacurate location', 'gps off']
  },
  {
    index: 14,
    ques: 'How secure is the lock against hacking?',
    ans: 'The lock uses encrypted communication protocols and advanced access control mechanisms, making it highly secure against hacking.',
    category: 'general',
    keyword: ['hacking', 'lock hacked', 'smartlock hacked']
  },
  {
    index: 15,
    ques: 'Can the lock function without GPS or internet?',
    ans: 'Yes, the lock can function in offline mode, but features like GPS tracking and commands from dashboard will not be available, only RFID will work in that case.',
    category: 'general',
    keyword: ['no internet', 'no gps', 'offline', 'no network']
  },
  {
    index: 16,
    ques: 'How can I troubleshoot if the lock stops responding?',
    ans: 'a. Restart the lock. \nb. Check the battery level. \nc. Verify network signal strength.',
    category: 'general',
    keyword: ['lock not working', 'does not responds', 'smartlock not working']
  },
  {
    index: 17,
    ques: 'Does the lock work offline, and what are its limitations without the internet?',
    ans: 'In offline mode, the lock can still lock and unlock using a RFID card, but real-time tracking and operations from the dashboard will not function.',
    category: 'general',
    keyword: ['offline', 'lock function', 'unlocked']
  },
  {
    index: 18,
    ques: 'What happens if someone tries to break or tamper with the lock?',
    ans: 'The lock triggers alarms and sends real-time alerts to the dashboard, and will also connect to the nearest police station in the area.',
    category: 'unlocking',
    keyword: ['break', 'alert', 'beeping', 'tamper', 'alarm']
  },
  {
    index: 19,
    ques: 'What happens if the lock is moved outside a geo-fenced area?',
    ans: 'An alert is sent to the dashboard, and the lock is set to lock automatically.',
    category: 'general',
    keyword: ['route diversion', 'alert', 'route diverted', 'outside geo-fence']
  },
  {
    index: 20,
    ques: 'How accurate is the GPS tracking of the lock?',
    ans: 'GPS tracking is accurate within a few meters, depending on signal strength and environmental factors.',
    category: 'general',
    keyword: ['GPS', 'gps tracking', 'accuracy']
  },
  {
    index: 21,
    ques: 'How do I fix connection issues with the lock (GPS, Wi-Fi, or cellular)?',
    ans: 'a. Ensure the lock is in an area with good signal strength. \nb. Restart the lock and recheck the settings.',
    category: 'general',
    keyword: ['no network', 'no wifi', 'no internet', 'offline']
  },
  {
    index: 22,
    ques: 'Does the lock support 4G/5G or specific network providers?',
    ans: 'Yes, the lock supports 4G connectivity and works with most major network providers.',
    category: 'general',
    keyword: ['network provider', 'SIM details', 'airtel', 'jio', 'sims']
  },
  {
    index: 23,
    ques: 'What happens if the battery dies while the lock is engaged?',
    ans: 'The lock will remain in its locked state until recharged.',
    category: 'general',
    keyword: ['battery dead', 'battery', 'low battery']
  },
  {
    index: 24,
    ques: 'Is the GPS smart lock weatherproof or durable for outdoor use?',
    ans: 'Yes, the lock is designed to be weatherproof and suitable for outdoor use in various environmental conditions.',
    category: 'general',
    keyword: ['waterproof', 'weatherproof', 'bad weather resistant']
  },
  {
    index: 25,
    ques: 'Does the lock require a Wi-Fi connection or SIM card?',
    ans: 'The lock requires a SIM card for cellular connectivity but does not rely on Wi-Fi for normal operations.',
    category: 'general',
    keyword: ['Network', 'wifi', 'sim', 'connection', 'negtwork connection']
  },
  {
    index: 26,
    ques: 'How can I log in to the SmartLock Dashboard?',
    ans: 'To log in, visit the URL https://smartlock.proxgy.com, enter your admin credentials, and click on Sign In.',
    category: 'general',
    keyword: ['log In', 'dashboard', 'smartlock dashboard', 'url']
  },
  {
    index: 27,
    ques: 'What should I do if I forget my password?',
    ans: 'Click on Forgot Password, enter your registered email, and follow the instructions sent to your email to reset the password.',
    category: 'general',
    keyword: ['Forgot password', 'login']
  },
  {
    index: 28,
    ques: 'How can I change my profile details?',
    ans: 'Navigate to "Profile Settings" in the Control Center, update your personal information, and save the changes.',
    category: 'general',
    keyword: ['change password', 'update password', 'profile settings']
  },
  {
    index: 29,
    ques: 'What is the URL for accessing the SmartLock Dashboard?',
    ans: 'The URL is https://smartlock.proxgy.com.',
    category: 'general',
    keyword: ['dashboard', 'url']
  },
  {
    index: 30,
    ques: 'How can I view system notifications?',
    ans: 'Notifications are displayed in the notification bar on the dashboard. Click the bell icon to view them.',
    category: 'general',
    keyword: ['notifications', 'system notifications', 'trips', 'alerts']
  },
  {
    index: 31,
    ques: 'Is the SmartLock Dashboard compatible with all browsers?',
    ans: 'It works best with modern browsers like Google Chrome, Mozilla Firefox, Microsoft Edge, and Safari.',
    category: 'general',
    keyword: ['compatible', 'broswers', 'dashboard']
  },
  {
    index: 32,
    ques: 'Can I log in from multiple devices simultaneously?,',
    ans: 'Yes, you can log in from multiple devices as long as your credentials are secure.',
    category: 'general',
    keyword: ['multiple device', 'login', 'dashboard', 'mobile']
  },
  {
    index: 33,
    ques: 'How do I log out of all sessions at once?',
    ans: 'Click on your profile image on the top right corner and click "Logout"',
    category: 'general',
    keyword: ['logout', 'dashboard', 'login']
  },
  {
    index: 34,
    ques: 'How can I reset my password?',
    ans: 'Use the "Forgot Password" option, or update it from the "Profile Settings" section in the Control Center.',
    category: 'general',
    keyword: ['forgot password', 'update password', 'reset password']
  },
  {
    index: 35,
    ques: 'Can I access the dashboard on a mobile device?',
    ans: 'Yes, the Lockator dashboard is mobile-responsive and can be accessed via a web browser on your mobile device.',
    category: 'general',
    keyword: ['mobile', 'responsive', 'works on mobile', 'small screen']
  },
  {
    index: 36,
    ques: 'How do I create a new device?',
    ans: 'Click on "Add New Device" in the Device section, fill in the required details (Device Name, IMEI, VIP Number, Unlock Password), and click "Add."',
    category: 'general',
    keyword: ['add device', 'new device', 'add new']
  },
  {
    index: 37,
    ques: 'What information is required to add a new device?',
    ans: 'Device Name, IMEI Number, VIP Number, and Unlock Password.',
    category: 'general',
    keyword: ['new device', 'add device', 'add new device']
  },
  {
    index: 38,
    ques: 'Where can I view a list of all devices?',
    ans: 'Go to the "Devices" section in the sidebar to see all listed devices in a table format.',
    category: 'general',
    keyword: ['list of devices', 'my devices', 'view list', 'view']
  },
  {
    index: 39,
    ques: 'How do I delete a device?',
    ans: 'Select the device from the list, click "Delete Device," and confirm the deletion.',
    category: 'general',
    keyword: ['delete device', 'delete', 'remove device', 'deactivate device']
  },
  {
    index: 40,
    ques: 'How can I assign a vehicle to a device?',
    ans: 'You can only assign a Vehicle to a device during creating a trip in Trip Management.',
    category: 'general',
    keyword: ['assign vehicle', 'map vehicle', 'add vehicle', 'vehicle']
  },
  {
    index: 41,
    ques: 'What details are included in the device report?',
    ans: 'Device Name, location, firmware version, online/offline status, trip assignments, battery level, and travel distance.',
    category: 'general',
    keyword: ['device report', 'device details', 'alerts', 'history', 'report']
  },
  {
    index: 42,
    ques: 'How do I update device settings?',
    ans: 'Select the device, click "Device Settings," and modify parameters like VIP Numbers, Unlock Channel, and Geofence Radius.',
    category: 'general',
    keyword: ['device settings', 'settings', 'change settings', 'update device']
  },
  {
    index: 43,
    ques: 'How can I manage RFID cards for a device?',
    ans: 'In "RFID Management," add, edit, or delete RFID cards associated with a device.',
    category: 'general',
    keyword: ['RFIDs', 'RFID', 'rfid management', 'add card']
  },
  {
    index: 44,
    ques: 'How do I enable power-saving mode for a device?',
    ans: 'Go to "Device Settings," and click the “Sleep” button to send the device in power save mode.',
    category: 'general',
    keyword: ['psm mode', 'psm data', 'psm', 'power save mode', 'sleep']
  },
  {
    index: 45,
    ques: 'How do I Unlock the Device from Device settings?',
    ans: 'Go to "Device Settings," and click the “Unlock” button to unlock the device.',
    category: 'unlocking',
    keyword: ['unlock device', 'device settings', 'unlock', 'open lock', 'open', 'dashboard']
  },
  {
    index: 46,
    ques: 'How do I Erase the Offline data from Device settings?',
    ans: 'Go to "Device Settings," and click the “Erase Flash” button to erase the offline data from the flash memory.',
    category: 'general',
    keyword: [
      'offline',
      'offline data',
      'device settings',
      'erase flash',
      'flash memory',
      'empty flash'
    ]
  },
  {
    index: 47,
    ques: 'How do I Reboot the Device from Device settings?',
    ans: 'Go to "Device Settings," and click the “Reboot” button to reboot the device.',
    category: 'general',
    keyword: ['reboot', 'restart', 'reset', 'device settings']
  },
  {
    index: 48,
    ques: 'What does the color of the lock icon indicate in the dashboard?',
    ans: 'A green lock indicates an online device, while a red lock indicates an offline device.',
    category: 'general',
    keyword: ['colour', 'lock colour', 'lock icon', 'icon', 'dashboard']
  },
  {
    index: 49,
    ques: 'How can I view existing user roles?',
    ans: 'Navigate to "User Management," select the "Roles" tab, and view the list of roles.',
    category: 'usermanagement',
    keyword: ['view roles', 'roles', 'user management']
  },
  {
    index: 50,
    ques: 'How do I create a new user role?',
    ans: 'Click "Add Role," enter the role name and description, enable or disable specific permissions, and click "Create Role."',
    category: 'usermanagement',
    keyword: ['create new role', 'create role', 'add role']
  },
  {
    index: 51,
    ques: 'How can I edit an existing user role?',
    ans: 'Select the role, click the edit icon, update permissions, and save the changes.',
    category: 'usermanagement',
    keyword: ['edit role', 'role', 'update role']
  },
  {
    index: 52,
    ques: 'How do I delete a user role?',
    ans: 'Select the role, click the delete icon, and confirm the deletion.',
    category: 'usermanagement',
    keyword: ['delete role', 'role', 'delete icon']
  },
  {
    index: 53,
    ques: 'How can I view a list of all registered users?',
    ans: 'In "userManagement," switch to the "Users" tab to see the list of registered users.',
    category: 'usermanagement',
    keyword: ['view users', 'users', 'user', 'view user', 'registered user']
  },
  {
    index: 54,
    ques: 'How do I add a new user?',
    ans: 'Click "Add User," enter the user details (name, email, phone, role), and click "Create User."',
    category: 'usermanagement',
    keyword: ['add user', 'add new user', 'user', 'users', 'register user']
  },
  {
    index: 55,
    ques: 'How can I edit user information?',
    ans: 'Select the user, click the edit icon, update details, and save the changes.',
    category: 'usermanagement',
    keyword: ['edit user', 'user', 'users', 'update user']
  },
  {
    index: 56,
    ques: 'How do I delete a user from the system?',
    ans: 'Select the user, click the delete icon, and confirm the deletion.',
    category: 'usermanagement',
    keyword: ['delete user', 'user', 'users', 'remove user']
  },
  {
    index: 57,
    ques: 'Can I assign multiple roles to a single user?',
    ans: 'No, users can be assigned only one role at a time.',
    category: 'usermanagement',
    keyword: ['assign roles', 'role management', 'role', 'roles']
  },
  {
    index: 58,
    ques: 'How do I deactivate a user account?',
    ans: 'In the "Users" tab, select the user and change their status to "Inactive."',
    category: 'userManagement',
    keyword: ['deactivate', 'user', 'users', 'deactivate users']
  },
  {
    index: 59,
    ques: 'How do I create a new trip?',
    ans: 'Click "Add Trip," select devices, fill in details (route, vehicle, driver, start time), and click "Create Trip."',
    category: 'general',
    keyword: ['create trip', 'new trip', 'add trip', 'trip', 'add new trip']
  },
  {
    index: 60,
    ques: 'What details are required to create a trip?',
    ans: 'Devices, route, vehicle, driver details, start time, and trip name.',
    category: 'general',
    keyword: ['add trip', 'trip', 'create trip']
  },
  {
    index: 61,
    ques: 'How can I view the list of all trips?',
    ans: 'Go to the "Trips" section to see a list of all scheduled and completed trips.',
    category: 'general',
    keyword: ['view trips', 'trips', 'trip', 'trip list']
  },
  {
    index: 62,
    ques: 'How do I view the details of a specific trip?',
    ans: 'Click on the trip name in the list to access detailed trip information.',
    category: 'general',
    keyword: ['trips', 'trip', 'view trip', 'trip id']
  },
  {
    index: 63,
    ques: 'How can I unlock a device during a trip?',
    ans: 'Select the trip, click "Unlock Device," and confirm the action.',
    category: 'unlocking',
    keyword: ['unlock device', 'trips', 'trip', 'open', 'device', 'lock']
  },
  {
    index: 64,
    ques: 'What is geofencing, and how do I enable it for a trip?',
    ans: 'Geofencing restricts device unlocking to specific locations. Enable it by clicking "Geofencing Enable" in the trip settings.',
    category: 'general',
    keyword: ['geofence', 'trip', 'trips', 'geofencing', 'enable geofence']
  },
  {
    index: 65,
    ques: 'How can I end a trip?',
    ans: 'Click the "End Trip" button in the trip details.',
    category: 'general',
    keyword: ['end trip', 'trip', 'trips']
  },
  {
    index: 66,
    ques: 'How do I delete a trip?',
    ans: 'Select the trip, click "Delete Trip," and confirm the deletion.',
    category: 'general',
    keyword: ['delete trip', 'trips', 'trips', 'delete']
  },
  {
    index: 67,
    ques: 'Can I assign multiple devices to a single trip?',
    ans: 'Yes, you can assign multiple devices when creating a trip.',
    category: 'general',
    keyword: ['multiple devices', 'devices', 'trip', 'trips', 'assign devices']
  },
  {
    index: 68,
    ques: 'How can I access the lock history of a trip?',
    ans: 'In the trip details, switch to the "Lock History" tab.',
    category: 'general',
    keyword: ['history', 'devices', 'device', 'report', 'lock', 'lock history']
  },
  {
    index: 69,
    ques: 'What settings can I configure for devices in the Control Center?',
    ans: 'Unlock Channel, Notification Frequency, Power-Save Mode, VIP Numbers, and Geofence Radius.',
    category: 'general',
    keyword: ['control center', 'device settings', 'settings', 'device']
  },
  {
    index: 70,
    ques: 'How do I update the notification frequency for devices?',
    ans: 'Go to "Device Settings" in the Control Center and adjust the "Notification Frequency."',
    category: 'general',
    keyword: ['notification', 'frequency', 'server data update', 'lock', 'device', 'settings']
  },
  {
    index: 71,
    ques: 'How can I enable or disable geofencing alerts?',
    ans: 'Navigate to "Device Settings," and toggle the geofencing alert option.',
    category: 'general',
    keyword: ['geofence', 'geofencing', 'alerts', 'lock', 'alarm', 'route divert']
  },
  {
    index: 72,
    ques: 'How do I update my profile settings?',
    ans: 'Go to "Profile Settings" in the Control Center and update your details.',
    category: 'general',
    keyword: ['prfile settings', 'settings', 'update settings']
  },
  {
    index: 73,
    ques: 'How can I change my account password?',
    ans: 'In "Profile Settings," select "Change Password," and follow the instructions.',
    category: 'general',
    keyword: ['passwrod', 'change password', 'update settings', 'settings']
  },
  {
    index: 74,
    ques: 'Is it possible to edit the geofence radius for a device?',
    ans: 'Yes, update it in the "Device Settings" under the Control Center.',
    category: 'general',
    keyword: ['geofencing', 'geofence', 'lock', 'settings', 'geofence radius', 'radius']
  },
  {
    index: 75,
    ques: 'How do I configure shipment delay allowances?',
    ans: 'Use the "Shipment Delay Allowance" setting in the Control Center.',
    category: 'general',
    keyword: ['shipment delay', 'lock', 'delay', 'allowance', 'settings']
  },
  {
    index: 76,
    ques: 'What is the purpose of the VIP mobile number in device settings?',
    ans: 'VIP numbers receive priority alerts and notifications from the devices.',
    category: 'general',
    keyword: ['VIP number', 'whitelisted number', 'settings', 'SMS']
  },
  {
    index: 77,
    ques: 'How do I create a new support ticket?',
    ans: 'Click "Create New Ticket," enter the required details, attach images if needed, and submit the ticket.',
    category: 'general',
    keyword: ['create ticket', 'help', 'ticket', 'create help']
  },
  {
    index: 78,
    ques: 'Where can I view previously submitted tickets?',
    ans: 'Go to the "Help Center" and click "Previous Tickets" to see all submitted queries.',
    category: 'general',
    keyword: ['previous ticket', 'help', 'view ticket']
  }
];
